<div class="flex align-c justify-c height-100 width-100 pos-a"
  style="top: 0px;bottom: 0px;left: 0px;right: 0px;background:#dbedff1c;z-index: 1;">
  <div class="flex align-c justify-c height-100 width-100">
    <div class="pre-loader" [style.width]="size+'px'" [style.height]="size+'px'"></div>
  </div>
</div>